<template>
  <div :inert="showModal || isDeleteModal" aria-hidden="showModal || isDeleteModal">
    <div class="flex flex-wrap gap-3 mb-4 justify-end items-center">
      <input type="text"  placeholder="TC veya Ehliyet No ile ara..."  v-model="searchQuery"
        class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100  focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
      <input type="text" placeholder="Ad Soyad ile ara..." v-model="searchNameQuery"
        class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100  focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
              <button @click="createModal"
        class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
        + Sürücü Ekle
      </button>
    </div>

    <div
      class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg  text-primary-text dark:text-gray-100  pb-3 shadow-md">
      <div class="w-full overflow-x-auto">
        <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
          <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
            <tr>
              <th class="px-3 md:px-6 py-2 md:py-4">Ad Soyad</th>
              <th class="px-3 md:px-6 py-2 md:py-4">TC No</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Doğum Tarihi</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Telefon</th>
              <th class="px-3 md:px-6 py-2 md:py-4">İl</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Ehliyet No</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Sürücü Durum</th>
              <th class="px-3 md:px-6 py-2 md:py-4"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="driver in paginatedDrivers" :key="driver.driver_id"
              class="border-b transition hover:light-hover hover:dark:bg-gray-800 ">
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100  ">
                {{ driver.driver_name }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium  text-primary-text dark:text-gray-100 ">
                {{ driver.driver_tcno }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4">
                  {{
                  driver.driver_dt && !isNaN(new Date(driver.driver_dt))
                    ? new Date(driver.driver_dt).toLocaleString("tr-TR", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                    })
                    : "-"
                }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100  ">
                {{ driver.driver_telno }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium  text-primary-text dark:text-gray-100 ">
                {{ driver.driver_province }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100  ">
                {{ driver.driver_licenceno }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4">
                <span :class="{
                  'px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800': driver.driver_status === 1,
                  'px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800': driver.driver_status === 0
                }">
                  {{ driver.driver_status === 1 ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 flex gap-2">
                <button @click="editModal(driver)" class="relative group">
                  <PencilSquareIcon
                    class="w-5 h-5 text-gray-500 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Düzenle</span>
                </button>
                <button @click="deleteModal(driver)" class="relative group">
                  <TrashIcon class="w-5 h-5 text-red-500 hover:text-red-600" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Sil</span>
                </button> 
              </td>
            </tr>

             <tr v-if="paginatedDrivers.length === 0">
    <td colspan="8" class="text-center text-gray-500 pt-10">
      Kayıtlı bir sürücü bulunmamaktadır.
    </td>
  </tr>
          </tbody>
        </table>
      </div>

      <AppPagination :currentPage="currentPage" :totalPages="totalPages" @prev-page="currentPage--"
        @next-page="currentPage++" @go-to-page="page => currentPage = page"
         @update:pageSize="handlePageSizeChange"
        :pageSize="pageSize" />
    </div>

  </div>

  <DriverModal :isModalOpen="showModal" :modalMode="isEditMode ? 'edit' : 'create'" :driver="selectedDriver"
    @submit-driver="saveDriver" @close="showModal = false" />

  <DeleteModal v-if="isDeleteModal" :item="selectedDriver" message="Bu şoförü silmek istediğinizden emin misiniz?"
    @close="isDeleteModal = false" @confirm-delete="handleDelete" @click.self="isDeleteModal = false" />

</template>

<script>
import { getApi, deleteApi, postApi, putApi } from "@/services/api";
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import DriverModal from '@/components/Modals/DriverModal.vue';
import { PencilSquareIcon, TrashIcon } from '@heroicons/vue/24/outline';

export default {
  name: "AllDriver",
  components: {
    PencilSquareIcon,
    TrashIcon,
    DeleteModal,
    DriverModal
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      totalDriversCount: 0,
      searchQuery: "",
      searchNameQuery: "",
      selectedDriver: null,
      isDeleteModal: false,
      showModal: false,
      isEditMode: false,
      drivers: [],
    };
  },
  computed: {
    totalPages() {
      const nameQ = this.searchNameQuery.trim();
      const idQ = this.searchQuery.trim();
      const query = nameQ.length >= 3 ? nameQ : idQ;

      if (query.length >= 3) {
        return Math.ceil(this.drivers.length / this.pageSize);
      }

      return Math.ceil(this.totalDriversCount / this.pageSize);
    },

    paginatedDrivers() {
      const nameQ = this.searchNameQuery.trim();
      const idQ = this.searchQuery.trim();
      const query = nameQ.length >= 3 ? nameQ : idQ;

      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;

      if (query.length >= 3) {
        return this.drivers.slice(start, end);
      }

      return this.drivers;
    },
  },

  async mounted() {
    this.fetchDrivers();
  },

  methods: {
    createModal() {
      this.selectedDriver = null;
      this.isEditMode = false;
      this.showModal = true;
    },
    editModal(driver) {
      this.selectedDriver = driver;
      this.isEditMode = true;
      this.showModal = true;
    },
    deleteModal(driver) {
      this.selectedDriver = driver;
      this.isDeleteModal = true;
    },

    async fetchDrivers(by = 'license') {
      const isName = by === 'name';
      const q = (isName ? this.searchNameQuery : this.searchQuery).trim();
      if (q.length >= 3) {
        let url = isName
          ? `/drivers/query/name/${encodeURIComponent(q)}`
          : `/drivers/query/${encodeURIComponent(q)}`;
        const response = await getApi(url);

        this.drivers = Array.isArray(response) ? response : [];
        this.totalDriversCount = this.drivers.length;
      }
      else {
        const take = this.pageSize;
        const skip = (this.currentPage - 1) * this.pageSize;
        const url = `/drivers/${take}/${skip}`;
        const response = await getApi(url);
        this.drivers = response.drivers;
        this.totalDriversCount = response.total_result;
      }
    },

    

    async saveDriver(driverData) {

      try {
        if (driverData.driver_tcno) {
          const response = await getApi(`/drivers/query/${encodeURIComponent(driverData.driver_tcno)}`);
          const existingDrivers = Array.isArray(response) ? response : [];

          if (!this.isEditMode || (this.isEditMode && this.selectedDriver.driver_tcno !== driverData.driver_tcno)) {
            const existingDriverTC = existingDrivers.find(driver =>
              driver.driver_tcno === driverData.driver_tcno
            );

            if (existingDriverTC) {
              this.$toast.error('Bu TC numarası zaten kayıtlı!');
              return;
            }
          }
        }

        if (this.isEditMode) {
          await putApi(`/drivers/${driverData.driver_id}`, driverData);
          this.$toast.success("Sürücü güncellendi");
        } else {
          await postApi('/drivers/', driverData);
          this.$toast.success("Sürücü eklendi");
        }

        this.showModal = false;
        await this.fetchDrivers();

      } catch (err) {
        this.$toast.error("İşlem sırasında hata oluştu!");
      }
    },


    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.currentPage = 1;
      this.fetchDrivers();
    },

    async handleDelete() {
      try {
        await deleteApi(`/drivers/${this.selectedDriver.driver_id}`);
        this.drivers = this.drivers.filter(d => d.driver_id !== this.selectedDriver.driver_id);
        this.$toast.success("Şoför başarıyla silindi!");
      } catch (error) {
        this.$toast.error("Silme işlemi sırasında hata oluştu!");
      } finally {
        this.isDeleteModal = false;
        this.selectedDriver = null;
      }
    },
  },

  watch: {
    searchQuery: {
      handler(val) {
        this.currentPage = 1;
        if (val.trim().length === 0 || val.trim().length >= 3) {
          this.fetchDrivers();
        }
      },
      immediate: false,
    },
    searchNameQuery: {
      handler(val) {
        this.currentPage = 1;
        if (val.trim().length === 0 || val.trim().length >= 3) {
          this.fetchDrivers('name');
        }
      },
      immediate: false,
    },
    currentPage() {
      this.fetchDrivers();
    },
    pageSize() {
      this.currentPage = 1;
      this.fetchDrivers();
    }
  }

};
</script>